import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const PrivacyPolicy = () => {
  return (
    <Container fluid className="py-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={12}>
            <Card className="shadow-sm">
              <Card.Header 
                className="text-center py-4"
                style={{ 
                  background: 'linear-gradient(135deg, #fb8b24 0%, #f39c12 100%)',
                  color: 'white',
                  border: 'none'
                }}
              >
                <h1 className="mb-2 fw-bold">Privacy Policy</h1>
                <p className="mb-0">Innovatix Technology Partners</p>
                <small>Last updated: 11/12/2025</small>
              </Card.Header>
              
              <Card.Body className="p-4">
                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>1. Introduction</h2>
                  <p className="text-muted">
                    Innovatix Technology Partners ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered QA automation platform and related services (collectively, the "Service").
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>2. Information We Collect</h2>
                  
                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>2.1 Personal Information</h5>
                  <p className="text-muted mb-3">
                    We may collect personal information that you provide directly to us, including:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>Name, email address, and contact information</li>
                    <li>Company name and job title</li>
                    <li>Account credentials and profile information</li>
                    <li>Communication preferences</li>
                  </ul>

                  <h5 className="h6 fw-bold mb-2" style={{ color: '#fb8b24' }}>2.2 Usage Information</h5>
                  <p className="text-muted mb-3">
                    We automatically collect certain information about your use of our Service:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>Document uploads and processing data</li>
                    <li>Generated test cases, automation scripts, and reports</li>
                    <li>Usage patterns and feature interactions</li>
                    <li>Device information and browser type</li>
                    <li>IP address and location data</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>3. How We Use Your Information</h2>
                  <p className="text-muted mb-3">We use the collected information for the following purposes:</p>
                  <ul className="text-muted mb-3">
                    <li>To provide, maintain, and improve our AI-powered QA services</li>
                    <li>To process and generate test cases, automation scripts, and documentation</li>
                    <li>To communicate with you about your account and our services</li>
                    <li>To provide customer support and technical assistance</li>
                    <li>To analyze usage patterns and enhance our platform</li>
                    <li>To comply with legal obligations and protect our rights</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>4. Data Security</h2>
                  <p className="text-muted mb-3">
                    We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>Encryption of data in transit and at rest</li>
                    <li>Regular security assessments and updates</li>
                    <li>Access controls and authentication measures</li>
                    <li>Secure data storage and backup procedures</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>5. Information Sharing</h2>
                  <p className="text-muted mb-3">
                    We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
                  </p>
                  <ul className="text-muted mb-3">
                    <li>With your explicit consent</li>
                    <li>To comply with legal obligations or court orders</li>
                    <li>To protect our rights, property, or safety</li>
                    <li>With trusted service providers who assist in our operations</li>
                    <li>In connection with a business transfer or acquisition</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>6. Data Retention</h2>
                  <p className="text-muted mb-3">
                    We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this Privacy Policy. We will delete or anonymize your information when it is no longer needed, unless we are required to retain it for legal or regulatory purposes.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>7. Your Rights</h2>
                  <p className="text-muted mb-3">You have the following rights regarding your personal information:</p>
                  <ul className="text-muted mb-3">
                    <li>Access and review your personal information</li>
                    <li>Correct or update inaccurate information</li>
                    <li>Request deletion of your personal information</li>
                    <li>Object to processing of your information</li>
                    <li>Data portability and export</li>
                    <li>Withdraw consent where applicable</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>8. Cookies and Tracking</h2>
                  <p className="text-muted mb-3">
                    We use cookies and similar tracking technologies to enhance your experience, analyze usage, and provide personalized content. You can control cookie settings through your browser preferences.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>9. International Data Transfers</h2>
                  <p className="text-muted mb-3">
                    Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your information in accordance with applicable data protection laws.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>10. Children's Privacy</h2>
                  <p className="text-muted mb-3">
                    Our Service is not intended for children under 13 years of age. We do not knowingly               collect personal information from children under 13. If we become aware that we have 
                    collected such information, we will take steps to delete it promptly.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>11. Changes to This Policy</h2>
                  <p className="text-muted mb-3">
                    We may update this Privacy Policy from time to time. We will notify you of any material 
                    changes by posting the new Privacy Policy on this page and updating the "Last updated" 
                    date. Your continued use of our Service after such changes constitutes acceptance of the 
                    updated policy.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="h4 fw-bold mb-3" style={{ color: '#36454f' }}>12. Contact Us</h2>
                  <p className="text-muted mb-3">
                    If you have any questions about this Privacy Policy or our data practices, please contact us:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Innovatix Technology Partners</strong></p>
                    <p className="mb-1">135 Route 202/206, Suite 9</p>
                    <p className="mb-1">Bedminster, NJ 07921</p>
                    <p className="mb-1">Phone: 973-889-0500 Ext 1</p>
                    <p className="mb-0">Email: privacy@innovatixinc.com</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default PrivacyPolicy;